// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';
import { BaseProps } from '../Base';
import { CheckboxSize } from '.';

interface StyledCheckboxProps extends BaseProps {
  size?: CheckboxSize;
}

export const StyledCheckbox = styled.span<StyledCheckboxProps>`
  flex-shrink: 0;
  position: relative;
  display: inline-block;
  height: ${(props) => props.theme.checkboxSizes[props.size || 'md'].height};
  width: ${(props) => props.theme.checkboxSizes[props.size || 'md'].width};
  cursor: pointer;
`;

export const HiddenCheckbox = styled.input`
  position: absolute;
  height: 100%;
  width: 100%;
  margin: 0;
  visibility: hidden;
`;

export const StyledCheckmark = styled.div<StyledCheckboxProps>`
  color: ${(props) => props.theme.inputs.checked.fontColor};
  display: inline-block;
  height: 100%;
  width: 100%;
  position: relative;
  pointer-events: none;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: ${(props) => props.theme.inputs.bgd};
    border: ${(props) => props.theme.inputs.border};
    border-width: ${(props) =>
      props.theme.checkboxSizes[props.size || 'md'].borderWidth};
    border-radius: ${(props) => props.theme.radii.small};
  }

  > svg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  ${HiddenCheckbox}:checked ~ &::before {
    background-color: ${(props) => props.theme.inputs.checked.bgd};
    border: ${(props) => props.theme.inputs.checked.border};
  }
`;
